import { API } from "../../main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  CREATE_DELETE: ({ commit }, { endpoint, data }) => {
    return new Promise((resolve, reject) => {
      API.delete.byEndpoint(
        endpoint,
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_DELETE_VALIDATION: ({ commit }, { endpoint, data }) => {
    return new Promise((resolve, reject) => {
      API.delete.validationByEndpoint(
        endpoint,
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/delete.js